export const MODULE = 'transactionRolling';
